/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Résultat du test à blanc d'une formule.
 * @export
 * @interface TestExpressionResponse
 */
export interface TestExpressionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TestExpressionResponse
     */
    isSuccess: boolean;
    /**
     * Formule telle qu'elle serait enregistrée (espaces retirés, séparateur virgule, fonctions en casse fixe).
     * @type {string}
     * @memberof TestExpressionResponse
     */
    canonicalExpression: string;
    /**
     * Codes des variables référencées par la formule.
     * @type {Array<string>}
     * @memberof TestExpressionResponse
     */
    variables: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TestExpressionResponse
     */
    result?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TestExpressionResponse
     */
    errorMessage?: string | null;
}

/**
 * Check if a given object implements the TestExpressionResponse interface.
 */
export function instanceOfTestExpressionResponse(value: object): value is TestExpressionResponse {
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('canonicalExpression' in value) || value['canonicalExpression'] === undefined) return false;
    if (!('variables' in value) || value['variables'] === undefined) return false;
    return true;
}

export function TestExpressionResponseFromJSON(json: any): TestExpressionResponse {
    return TestExpressionResponseFromJSONTyped(json, false);
}

export function TestExpressionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestExpressionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'],
        'canonicalExpression': json['canonicalExpression'],
        'variables': json['variables'],
        'result': json['result'] == null ? undefined : json['result'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function TestExpressionResponseToJSON(json: any): TestExpressionResponse {
    return TestExpressionResponseToJSONTyped(json, false);
}

export function TestExpressionResponseToJSONTyped(value?: TestExpressionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'canonicalExpression': value['canonicalExpression'],
        'variables': value['variables'],
        'result': value['result'],
        'errorMessage': value['errorMessage'],
    };
}

